import type { BookmarkItem, Bookmark } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The requester's saved clips + documents, newest first, each with its target embedded (clip: title,
// signed poster, rule · document: title, format, size) for the Bookmarked list.
export async function listBookmarks(): Promise<BookmarkItem[]> {
  const res = await api.get<Envelope<BookmarkItem[]>>('/bookmarks');
  return unwrap(res.data);
}

// Save / unsave a clip. Both idempotent server-side, so the Save toggle can fire freely.
export async function addBookmark(clipId: string): Promise<void> {
  await api.post<Envelope<unknown>>(`/clips/${clipId}/bookmark`);
}

export async function removeBookmark(clipId: string): Promise<void> {
  await api.delete<Envelope<null>>(`/clips/${clipId}/bookmark`);
}

// Save / unsave a document. Same idempotent shape as the clip toggle.
export async function addDocumentBookmark(documentId: string): Promise<void> {
  await api.post<Envelope<unknown>>(`/documents/${documentId}/bookmark`);
}

export async function removeDocumentBookmark(documentId: string): Promise<void> {
  await api.delete<Envelope<null>>(`/documents/${documentId}/bookmark`);
}

// Set or clear a bookmark's personal note (empty string clears it server-side).
export async function updateBookmarkNote(bookmarkId: string, note: string): Promise<Bookmark> {
  const res = await api.patch<Envelope<Bookmark>>(`/bookmarks/${bookmarkId}`, { note });
  return unwrap(res.data);
}
